// extracted by mini-css-extract-plugin
export default {"total":"Total_total__dVmJm","row":"Total_row__ed1uI","item":"Total_item__7cM2t"};